<template>
	<CModal title="Ajouter un point de retrait" size="lg" :show.sync="showModal">
		<form ref="mainForm" action="/api/pick_up_points" method="post" axiosMethod="post">
			<pickup-points-form />
		</form>

		<template #footer>
			<CButton color="secondary" v-on:click="showModal = false">Annuler</CButton>
			<CButton color="success" v-on:click="onSubmit($refs.mainForm)">Sauvegarder</CButton>
		</template>
	</CModal>
</template>

<script>
	import PickupPointsForm from '@/views/pages/pick-up-points/pickup-points-form';
	export default {
		name: 'pickup-points-add',
		components: { PickupPointsForm },
		data() {
			return {
				showModal: false,
			};
		},
		methods: {
			onSubmit: async function (form) {
				await this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.$toast.success('Le point de retrait a bien été crée.');
						this.showModal = false;
						this.$emit('refresh');
					}
				});
			},
		},
	};
</script>

<style scoped></style>
